import { render, staticRenderFns } from "./PreviewBlockEditor.vue?vue&type=template&id=602873fc&scoped=true&"
import script from "./PreviewBlockEditor.vue?vue&type=script&lang=js&"
export * from "./PreviewBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./PreviewBlockEditor.vue?vue&type=style&index=0&id=602873fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602873fc",
  null
  
)

export default component.exports